import { render, staticRenderFns } from "./store_pass.vue?vue&type=template&id=609fa28f&scoped=true"
import script from "./store_pass.vue?vue&type=script&lang=js"
export * from "./store_pass.vue?vue&type=script&lang=js"
import style0 from "./store_pass.vue?vue&type=style&index=0&id=609fa28f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609fa28f",
  null
  
)

export default component.exports